module.exports = __webpack_public_path__ + "img/9788965743507.8925fe7a.jpg";